import { TFunction } from 'i18next';

// Map database species codes to translation keys
const speciesKeyMap: Record<string, string> = {
  'dog': 'categories.dogs',
  'cat': 'categories.cats',
  'bird': 'categories.birds',
  'fish': 'categories.fish',
  'reptile': 'categories.reptiles',
  'small_pet': 'categories.smallPets',
  'horse': 'categories.horses',
  'cattle': 'categories.cattle',
  'other': 'categories.other',
};

// Singular form translations
const speciesSingularKeyMap: Record<string, string> = {
  'dog': 'species.dog',
  'cat': 'species.cat',
  'bird': 'species.bird',
  'fish': 'species.fish',
  'reptile': 'species.reptile',
  'small_pet': 'species.small_pet',
  'horse': 'species.horse',
  'cattle': 'species.cattle',
  'other': 'species.other',
};

// Fallback display names (used when translation is missing)
const speciesFallbacks: Record<string, string> = {
  'dog': 'Dog',
  'cat': 'Cat',
  'bird': 'Bird',
  'fish': 'Fish',
  'reptile': 'Reptile',
  'small_pet': 'Small Pet',
  'horse': 'Horse',
  'cattle': 'Cattle',
  'other': 'Other',
};

/**
 * Translate a species code to its localized display name (plural form for categories)
 */
export function translateSpecies(speciesCode: string | null | undefined, t: TFunction): string {
  if (!speciesCode) return '';
  
  const key = speciesKeyMap[speciesCode];
  if (key) {
    const translated = t(key, speciesFallbacks[speciesCode] || speciesCode);
    return translated;
  }
  
  // If no mapping found, try to format the raw value nicely
  return speciesCode.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

/**
 * Translate a species code to its localized display name (singular form)
 */
export function translateSpeciesSingular(speciesCode: string | null | undefined, t: TFunction): string {
  if (!speciesCode) return '';
  
  const key = speciesSingularKeyMap[speciesCode];
  if (key) {
    const translated = t(key, speciesFallbacks[speciesCode] || speciesCode);
    return translated;
  }
  
  // If no mapping found, try to format the raw value nicely
  return speciesCode.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
